var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IconInShape',{staticClass:"hover:bg-sec-4 cursor-pointer",attrs:{"shape-type":"circle","shape-size":"40px","shape-color":_vm.$tokens.color_concrete,"icon-name":"pointer-thin","icon-size":"20px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }